import {
  CREATE_NEW_STORAGES,
  DELETE_STORAGES,
  GET_BOX,
  GET_BOX_DETAILS,
  GET_USER_ITEM,
  GET_USER_ITEMS,
  MOVE_STORAGE_SITE_LOCATION,
  NOTIFY_USER_BROKEN_ITEM,
  RESET_BOX_COLUMN,
  SET_BOX_COLUMN,
} from '../actionTypes';

const initialState = {
  data: [],
  isLoading: false,
  isLoadingDetails: false,
  error: false,
  message: '',
  selectedBox: {},
  items: [],
  selectedItem: {},
  itemMeta: {},
  newStorages: false,
  deletedStorage: false,
  notifiedUser: false,
  storageMoved: false,
  needstorage: [],
  statuses: [],
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;
  const { data, needstorage, statuses } = state;
  let rackIndex;
  let rowIndex;
  let columnIndex;
  let status;
  let originalSlot;

  if (payload?.rack) rackIndex = data.data.findIndex((item) => item.rack_id === payload.rack);

  if (payload?.column) {
    rowIndex = data.data[rackIndex]
      .row.findIndex((item) => item.name === payload.column);
  }

  if (payload?.id) {
    columnIndex = data.data[rackIndex].row[rowIndex]
      .column.findIndex((item) => item.id === payload.id);
  }

  if (type === SET_BOX_COLUMN) {
    if (data.data[rackIndex].row[rowIndex].column[columnIndex].status === 'empty') {
      status = 'available';
    } else status = data.data[rackIndex].row[rowIndex].column[columnIndex].status;
    statuses.push(data.data[rackIndex].row[rowIndex].column[columnIndex].status);
    originalSlot = data.data[rackIndex].row[rowIndex].column[columnIndex].available_slot;
  }

  switch (type) {
    case SET_BOX_COLUMN:
      data.data[rackIndex].row[rowIndex].column[columnIndex].available_slot -= payload.needstorage;
      data.data[rackIndex].row[rowIndex].column[columnIndex].original_slot = originalSlot;
      data.data[rackIndex].row[rowIndex].column[columnIndex].status = status;
      needstorage.push(payload.needstorage);
      return {
        ...state,
        data,
        needstorage,
        statuses,
      };
    case RESET_BOX_COLUMN:
      data.data[rackIndex].row[rowIndex].column[columnIndex].available_slot += needstorage.pop();
      data.data[rackIndex].row[rowIndex].column[columnIndex].status = statuses.pop();
      return {
        ...state,
        data,
        needstorage,
        statuses,
      };
    case `${GET_BOX}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        courierSelected: false,
        selectedBox: {},
        newStorages: false,
        deletedStorage: false,
        notifiedUser: false,
        storageMoved: false,
      };
    case `${GET_BOX}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${GET_BOX}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        data: payload.data?.data || [],
      };
    case `${CREATE_NEW_STORAGES}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        newStorages: false,
      };
    case `${CREATE_NEW_STORAGES}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${CREATE_NEW_STORAGES}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        newStorages: true,
      };
    case `${DELETE_STORAGES}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        deletedStorage: false,
      };
    case `${DELETE_STORAGES}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${DELETE_STORAGES}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        deletedStorage: true,
      };
    case `${GET_USER_ITEMS}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        selectedItem: {},
      };
    case `${GET_USER_ITEMS}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${GET_USER_ITEMS}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        items: payload.data?.data?.data || [],
        itemMeta: {
          totalPage: payload.data?.data?.total_page,
        },
      };

    case `${GET_USER_ITEM}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        selectedItem: {},
      };
    case `${GET_USER_ITEM}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${GET_USER_ITEM}_FULFILLED`:
      return {
        ...state,
        error: false,
        message: '',
        selectedItem: payload.data?.data,
        isLoading: false,
      };

    case `${GET_BOX_DETAILS}_PENDING`:
      return {
        ...state,
        isLoadingDetails: true,
        error: false,
        selectedBox: {},
        notifiedUser: false,
      };
    case `${GET_BOX_DETAILS}_REJECTED`:
      return {
        ...state,
        isLoadingDetails: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${GET_BOX_DETAILS}_FULFILLED`:
      return {
        ...state,
        isLoadingDetails: false,
        error: false,
        message: '',
        selectedBox: payload.data?.data || {},
      };
    case `${NOTIFY_USER_BROKEN_ITEM}_PENDING`:
      return {
        ...state,
        error: false,
        notifiedUser: false,
      };
    case `${NOTIFY_USER_BROKEN_ITEM}_REJECTED`:
      return {
        ...state,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${NOTIFY_USER_BROKEN_ITEM}_FULFILLED`:
      return {
        ...state,
        error: false,
        message: '',
        notifiedUser: true,
      };
    case `${MOVE_STORAGE_SITE_LOCATION}_PENDING`:
      return {
        ...state,
        error: false,
        storageMoved: false,
      };
    case `${MOVE_STORAGE_SITE_LOCATION}_REJECTED`:
      return {
        ...state,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${MOVE_STORAGE_SITE_LOCATION}_FULFILLED`:
      return {
        ...state,
        error: false,
        message: '',
        storageMoved: true,
      };

    default:
      return state;
  }
}
